const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      left: '4.5vw',
      right: '4.5vw',
      top: 30,
      background: theme.colors[1],
      zIndex: theme.zindex.collectionNav,
      paddingTop: (props) => props.headerHeight,
      paddingBottom: 40,
      overflowY: 'auto',
      overflowX: 'hidden',
      borderTopLeftRadius: 27,
      borderTopRightRadius: 27,
      pointerEvents: 'none',
    },
    isOpen: {
      pointerEvents: 'all',
    },
    container: {
      padding: '0 2.5vw',
    },
    wrapper: {
      height: '100%',
      position: 'relative',
      margin: 0,
      color: theme.colors[0],
    },
    collectionNav: {
      '& ul': {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '& li': {
        width: '22%',
      },
    },
    navItem: {
      '&:hover': {
        '& img': {
          transform: 'scale(1.05)',
        },
      },
    },
    navImage: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      paddingBottom: '43%',
      overflow: 'hidden',
      display: 'block',
      '& img': {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        fontFamily: "'object-fit: cover;'",
        verticalAlign: 'middle',
        backfaceVisibility: 'hidden',
        transition: `all 0.3s ${theme.easings['power4.out']}`,
      },
    },
    navLabel: {
      display: 'block',
      marginTop: 10,
      textTransform: 'uppercase',
      fontSize: 14,
      color: theme.colors[2],
    },
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
